import { Utils } from "ag-grid-community";

let rtlScrollType = null;

/**
 * Detects how the current browser handles RTL scrollLeft values:
 * - "negative": (CSSOM standard - Chrome 85+, Firefox, Safari 14+) scrollLeft starts at 0 and decreases (negative) when scrolling left.
 * - "positive": (Legacy IE/Edge) scrollLeft starts at (scrollWidth - clientWidth) and decreases to 0 when scrolling left.
 * - "reverse": (Legacy WebKit) scrollLeft starts at 0 and increases (positive) when scrolling left.
 */
function getRtlScrollType() {
  if (rtlScrollType) {
    return rtlScrollType;
  }
  if (typeof document === "undefined" || !document.body) {
    return "negative";
  }

  const definer = document.createElement("div");
  definer.dir = "rtl";
  definer.style.position = "absolute";
  definer.style.top = "-9999px";
  definer.style.width = "4px";
  definer.style.height = "1px";
  definer.style.overflow = "scroll";

  const content = document.createElement("div");
  content.style.width = "20px";
  content.style.height = "1px";
  definer.appendChild(content);
  document.body.appendChild(definer);

  rtlScrollType = "reverse";
  if (definer.scrollLeft > 0) {
    rtlScrollType = "positive";
  } else {
    definer.scrollLeft = -1;
    if (definer.scrollLeft === -1) {
      rtlScrollType = "negative";
    }
  }

  document.body.removeChild(definer);
  return rtlScrollType;
}

// Monkey-patch AG Grid v19 Utils to prevent broken Chrome scroll behavior in RTL mode
if (Utils) {
  Utils.getScrollLeft = function (element, rtl) {
    var scrollLeft = element.scrollLeft;
    if (rtl) {
      var type = getRtlScrollType();
      if (type === "negative") {
        scrollLeft = Math.abs(scrollLeft);
      } else if (type === "positive") {
        scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
      }
      // If 'reverse', scrollLeft is already distance from right edge
    }
    return scrollLeft;
  };

  Utils.setScrollLeft = function (element, value, rtl) {
    if (rtl) {
      var type = getRtlScrollType();
      if (type === "negative") {
        value = -Math.abs(value);
      } else if (type === "positive") {
        value = element.scrollWidth - element.clientWidth - value;
      }
      // If 'reverse', value remains unchanged
    }
    element.scrollLeft = value;
  };
}

export default Utils;
